import { alpha, Card, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import classNames from "classnames";
import { forwardRef, ReactNode } from "react";
import { useTranslate } from "react-admin";
import { getIconColor, getWidgetIcon, WidgetProps } from "../common";

interface Props extends WidgetProps {
  children: ReactNode;
  editIcon?: ReactNode;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  icon: ({ icon }) => ({ color: getIconColor(icon, theme) }),
  colored: ({ icon }) => ({
    background: `linear-gradient(135deg, ${alpha(
      getIconColor(icon, theme),
      0.25
    )} 0%, ${alpha(getIconColor(icon, theme), 0.05)} 35%) !important`,
  }),
}));

export const Widget = forwardRef((props: Props, ref) => {
  const {
    className,
    icon,
    title,
    children,
    editIcon,
    configuration,
    onConfigurationSaved,
    ...rest
  } = props;
  const translate = useTranslate();
  const classes = useStyles(props);
  return (
    <Card style={{height: 'auto'}} className={classNames("widget", className)} ref={ref} {...rest}>
      <>
        <div className="widget-title">
          <div className={classNames("widget-title-icon", classes.icon)}>
            {getWidgetIcon(icon)}
          </div>
          <div className="widget-title-label">
            {translate(title, { _: title })}
          </div>
          {editIcon ? (
            <div className="widget-edit-icon widget-title-icon">{editIcon}</div>
          ) : null}
        </div>
        {children}
      </>
    </Card>
  );
});
